import { useMemo } from 'react';
import { makeSlugUnique, stringToSlugStartingWithPrefix } from '../../../utils/slug';
import { CUSTOMER_GROUP_SLUG_MAX_LENGTH } from '../constants';
import { useCustomerGroups } from './use-customer-groups';

export function useCreateUniqueSlugFromName() {
  const { data: existingGroups } = useCustomerGroups();

  const usedSlugs = useMemo(() => existingGroups.map((group) => group.slug), [existingGroups]);

  function createUniqueSlugFromName(name: string) {
    return makeSlugUnique(
      stringToSlugStartingWithPrefix(name, {
        maxLength: CUSTOMER_GROUP_SLUG_MAX_LENGTH,
      }),
      usedSlugs,
    );
  }

  return { createUniqueSlugFromName };
}
